import React from "react";
import { Table, Input, Select, Divider } from "antd";
import {
  FileText,
  Clock,
  CheckCircle,
  RefreshCcw,
  CloudDownload,
  Edit,
  Trash2,
} from "lucide-react";

const { Option } = Select;

const MonthlyInputs = () => {
  const columns = [
    { title: "Select", dataIndex: "select", key: "select" },
    { title: "Employee Code", dataIndex: "code", key: "code" },
    { title: "Employee Name", dataIndex: "name", key: "name" },
    { title: "Element Name", dataIndex: "element", key: "element" },
    { title: "Pay Date", dataIndex: "date", key: "date" },
    { title: "Amount", dataIndex: "amount", key: "amount" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div className="flex gap-3">
          <Edit className="w-4 h-4 cursor-pointer" />
          <Trash2 className="w-4 h-4 cursor-pointer" />
        </div>
      ),
    },
  ];

  const data = [
    {
      key: "1",
      select: "✓",
      code: "EMP001",
      name: "John Doe",
      element: "Basic Salary",
      date: "2024-01-31",
      amount: "RS 50,000",
    },
    {
      key: "2", 
      select: "✓",
      code: "EMP002",
      name: "Jane Smith",
      element: "Housing Allowance",
      date: "2024-01-31",
      amount: "RS 15,000",
    },
    {
      key: "3",
      select: "✓", 
      code: "EMP003",
      name: "Bob Wilson",
      element: "Transportation",
      date: "2024-01-31",
      amount: "RS 8,000",
    }
  ];

  return (
    <div className="p-3 shadow-[0_4px_6px_rgba(0,0,0,0.1),0_-4px_6px_rgba(0,0,0,0.05)] rounded-md">
      <div className="flex justify-between items-center pb-2 text-md">
        <div className="flex space-x-4">
          <span className="text-active-color flex items-center gap-1 font-medium">
            <FileText size={14} /> Draft (0)
          </span>
          <span className="text-gray-700 flex items-center gap-1">
            <Clock size={14} /> Pending (0)
          </span>
          <span className="text-gray-700 flex items-center gap-1">
            <CheckCircle size={14} /> Approved (0)
          </span>
          <span className="text-gray-700 flex items-center gap-1">
            <RefreshCcw size={14} /> Finalized (0)
          </span>
        </div>
       
      </div>
      <Divider />
      {/* Search + Create New Button */}
      <div className="flex justify-between items-center">
        <div className="flex w-full max-w-md gap-4 items-center">
          <Input placeholder="Search" className="w-full text-md" />
        </div>
      </div>

      {/* Table */}
      <div className="rounded mt-4">
        <Table
          columns={columns}
          dataSource={data}
          locale={{ emptyText: "No Data" }}
          scroll={{ x: 'max-content' }}
          pagination={{
            total: data.length,
            pageSize: 10,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} items`,
          }}
          className="bg-white rounded-lg border border-gray-200"
        />
      </div>
    </div>
  );
};

export default MonthlyInputs;
